import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { whatsappUrl, telUrl, DEFAULT_WA_MESSAGE } from "@/lib/contact";

export function WhatsAppButton({ message = DEFAULT_WA_MESSAGE, label = "Solicitar Guincho no WhatsApp", className = "", testid = "whatsapp-btn", size = "lg" }) {
  const pad = size === "lg" ? "px-8 py-4 text-base" : "px-6 py-3 text-sm";
  return (
    <a
      href={whatsappUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`group inline-flex items-center justify-center gap-3 rounded-sm bg-brand-whatsapp font-heading font-semibold uppercase tracking-wide text-white transition-transform duration-300 hover:scale-[1.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-whatsapp focus-visible:ring-offset-2 focus-visible:ring-offset-brand-obsidian ${pad} ${className}`}
    >
      <WhatsappLogo weight="fill" className="h-5 w-5 transition-transform duration-300 group-hover:rotate-6" />
      {label}
    </a>
  );
}

export function CallButton({ label = "Ligar Agora", className = "", testid = "call-btn", size = "lg" }) {
  const pad = size === "lg" ? "px-8 py-4 text-base" : "px-6 py-3 text-sm";
  return (
    <a
      href={telUrl()}
      data-testid={testid}
      className={`group inline-flex items-center justify-center gap-3 rounded-sm border border-white/30 bg-transparent font-heading font-semibold uppercase tracking-wide text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-brand-obsidian focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2 focus-visible:ring-offset-brand-obsidian ${pad} ${className}`}
    >
      <Phone weight="fill" className="h-5 w-5 transition-transform duration-300 group-hover:-rotate-12" />
      {label}
    </a>
  );
}
